import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import {
	DataRightsRequest,
	DataRightsResponse,
	DataRightsSearchCriteria,
	PaginatedDataRightsResponse
} from "../../definitions/data-rights";
import { AppConfigService } from "../app.config.service";
import { ApiService } from "./api.service";
import { BaseApiService } from "./base-api.service";

@Injectable({ providedIn: "root" })
export class DataRightsAdminService extends BaseApiService {
	constructor(
		private api: ApiService,
		appConfigService: AppConfigService
	) {
		const apiEndpoint: string = appConfigService.getConfigValue("API_ENDPOINT");
		super("mpapi/admin/data-rights", apiEndpoint);
	}

	search(
		criteria: DataRightsSearchCriteria
	): Observable<PaginatedDataRightsResponse> {
		return this.api.postAndThrowError(this.url("/search"), criteria);
	}

	getById(id: string): Observable<DataRightsResponse> {
		return this.api.getAndThrowError(this.url(`/${id}`));
	}

	create(request: DataRightsRequest): Observable<DataRightsResponse> {
		return this.api.postAndThrowError(this.url(), request);
	}

	update(id: string, request: DataRightsRequest): Observable<DataRightsResponse> {
		return this.api.putAndThrow(this.url(`/${id}`), request);
	}

	delete(id: string): Observable<void> {
		return this.api.delete(this.url(`/${id}`));
	}

	// ----- Files -----

	uploadFiles(id: string, files: File[]): Observable<DataRightsResponse> {
		const formData = new FormData();
		for (const file of files) {
			formData.append("files", file, file.name);
		}
		return this.api.postAndThrowError(this.url(`/${id}/files`), formData);
	}

	deleteFile(id: string, fileId: string): Observable<void> {
		return this.api.delete(this.url(`/${id}/files/${fileId}`));
	}
}
